import { Skeleton, Box } from '@mui/material';

const LoadingState = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          minHeight: '4rem',
          borderBottom: '1px solid lightgrey',
        }}
      >
        <Skeleton variant="text" sx={{ width: '100%', height: '100%', fontSize: '3rem' }} />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box>
          <Skeleton variant="rectangular" sx={{ width: '100%', height: '500px' }} />
        </Box>
      </Box>
    </Box>
  );
};

export default LoadingState;
